// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3bdCY","sendOtp":"AuthorizeToLogin_sendOtp__1eEl_"};